import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Dashboard from "@/pages/Dashboard";
import CaseManagerDashboard from "@/pages/CaseManagerDashboard";
import DeptHeadDashboard from "@/pages/DeptHeadDashboard";

/**
 * Tier-aware /dashboard route.
 *   Tier 1 → redirect to /my-tasks (field operators don't see the executive dashboard)
 *   Tier 2 → CaseManagerDashboard
 *   Tier 3 → DeptHeadDashboard (dept-specific)
 *   Tier 4 → existing CEO Dashboard (no regression)
 */
export default function DashboardRouter() {
  const { user, loading } = useAuth();
  if (loading) return null;
  const tier = user?.ux_tier ?? 4;
  if (tier === 1) return <Navigate to="/my-tasks" replace />;
  if (tier === 2) return <CaseManagerDashboard />;
  if (tier === 3) return <DeptHeadDashboard />;
  return <Dashboard />;  // Tier 4
}
